import { render, staticRenderFns } from "./HongKongStockTrade.vue?vue&type=template&id=342f0917&scoped=true"
import script from "./HongKongStockTrade.vue?vue&type=script&lang=js"
export * from "./HongKongStockTrade.vue?vue&type=script&lang=js"
import style0 from "./HongKongStockTrade.vue?vue&type=style&index=0&id=342f0917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f0917",
  null
  
)

export default component.exports